import { BENEFIT_CARD_IDS } from "../../data/siteContent";
import { useLocale } from "../../i18n/LocaleProvider";
import { Section } from "../layout/Section";

import styles from "./Benefits.module.css";

export function Benefits() {
  const { copy } = useLocale();

  return (
    <Section id="features" dark title={copy.benefits.title}>
      <div className={styles.grid}>
        {BENEFIT_CARD_IDS.map((id) => {
          const card = copy.benefits.cards[id];
          return (
            <article key={id} className={styles.card}>
              <div className={styles.icon} aria-hidden="true">
                ✦
              </div>
              <h3 className={styles.cardTitle}>{card.title}</h3>
              <p className={styles.cardText}>{card.description}</p>
            </article>
          );
        })}
      </div>
    </Section>
  );
}
